import { Add } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';
import React from 'react';

const AddCta: React.FC = () => (
	<Stack direction="row" alignItems="center" gap={0.5} data-testid="add-cta">
		<Add color="primary" />
		<Typography color="primary">{intl.tr('general.add')}</Typography>
	</Stack>
);

export default AddCta;
